<template>
    <v-card>
      <v-toolbar
            flat
            dark
            color="primary"
        >
          <v-card-text class="headline text-xs-center">{{ titulo }}</v-card-text>
      </v-toolbar>
      <v-stepper v-model="step" v-if="frentista">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card-text>
              <p style="text-align: center; color: red;">{{ texto }}</p>
              <v-form lazy-validation v-model="valid" ref="form" @submit="opcoes">
                <v-layout column justify-center>
                    <v-flex>
                        <v-text-field
                        :type="show ? 'text' : 'password'"
                        v-model="pin"
                        :append-icon="show ? 'visibility' : 'visibility_off'"
                        placeholder="****"
                        outline
                        counter="4"
                        single-line
                        hide-details
                        color="primary"
                        class="centered-input display-1 font-weight-black"
                        browser-autocomplete="off"
                        required
                        @click:append="show = !show"
                        :rules="[
                                v => {
                                    if (v) {
                                    return v.length && v.length == 4 || ''
                                    } else {
                                    return false
                                    }
                                }
                                ]"
                        mask="NNNN"
                        />
                    </v-flex>
                    <v-btn v-if="!redefinir && !cadastrar"  @click="redefinir = true" small flat color="primary">Redefinir PIN</v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-btn round @click="voltar">{{cadastrar ? 'Voltar': 'Cancelar'}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn round color="primary" @click="opcoes">Confirmar</v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="2">
            <p style="text-align: center; color: red;">{{ texto }}</p>
            <v-card-text>
              <v-text-field
                v-model="frentista.pessoa.email"
                class="pb-3"
                hide-details
                box label="E-mail"
                readonly
              />
              <v-text-field
                  v-model="login.password"
                  hide-details
                  class="pb-1"
                  box
                  label="Password"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                  @keyup.enter="fazerLogin"
              />
              <v-btn v-if="frentista.data_atualizacao_pin && !redefinir" @click="redefinir = true" small flat block color="primary">Redefinir PIN</v-btn>
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-btn round @click="voltar">{{cadastrar ? 'Voltar': 'Cancelar'}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="primary"
                @click="fazerLogin"
                @keyup.enter="fazerLogin"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
</template>

<script>
export default {
  props: ['frentistaSelecionado'],
  data () {
    return {
      login: { email: '', password: '' },
      cadastrar: false,
      show: false,
      pin: '',
      texto: 'Confirme sua senha',
      titulo: 'Cadastre seu PIN',
      valid: false,
      redefinir: false,
      logado: false,
      step: 1
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    frentista () {
      return this.$store.getters.frentista
    }
  },
  methods: {
    opcoes (event) {
      event.preventDefault()
      if (this.frentistaSelecionado && !this.cadastrar) {
        this.autenticar()
      } else if (this.redefinir && this.cadastrar) {
        this.editarFrentista()
      } else if (this.cadastrar) {
        this.editarFrentista()
      }
    },
    fazerLogin () {
      this.login.email = this.frentista.pessoa.email
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', { email: this.login.email, password: this.login.password }).then(value => {
          if (value) {
            this.cadastrar = true
            this.titulo = this.redefinir ? 'Redefina seu PIN' : 'Cadastre seu PIN'
            this.logado = false
            this.texto = '*Digite o PIN'
            this.step--
          }
        })
      }
    },
    autenticar () {
      if (this.$refs.form.validate() && this.pin && this.pin !== '') {
        this.$store.dispatch('autenticarPin', {
          pin: this.pin,
          id: this.frentista.id_frentista
        }).then(() => {
          this.cadastrar = true
          this.pin = ''
          this.show = false
          this.titulo = this.redefinir ? 'Redefina seu PIN' : 'Cadastre seu PIN'
          this.texto = '*Digite o PIN'
        })
      }
    },
    editarFrentista () {
      if (this.$refs.form.validate() && this.pin && this.pin !== '') {
        this.$store.dispatch('editarFrentista', {
          pin: this.pin,
          id: this.frentistaSelecionado ? this.frentistaSelecionado.id_frentista : null,
          frentista: this.frentista.id_frentista
        }).then(() => {
          this.fechar()
        })
      }
    },
    voltar () {
      if (this.frentista.id_frentista === this.frentistaSelecionado.id_frentista) {
        if (this.step === 2) {
          if (this.redefinir && this.frentista.data_atualizacao_pin) {
            this.fechar()
          } else if (this.redefinir) {
            this.limparCampos()
          } else {
            this.fechar()
          }
        } else {
          this.step++
          if (this.redefinir && this.frentista.data_atualizacao_pin) {
            this.texto = 'Confirme sua senha'
            this.login.email = ''
            this.login.password = ''
            this.pin = ''
            this.show = false
          } else {
            this.limparCampos()
          }
        }
      } else if (this.cadastrar || this.redefinir) {
        this.limparCampos()
        this.texto = '*Requer PIN do gerente'
      } else {
        this.fechar()
      }
    },
    limparCampos () {
      this.login.email = ''
      this.login.password = ''
      this.pin = ''
      this.texto = this.frentistaSelecionado.id_frentista === this.frentista.id_frentista ? 'Confirme sua senha' : '*Requer PIN do gerente'
      this.titulo = 'Cadastre seu PIN'
      this.cadastrar = false
      this.show = false
      this.redefinir = false
    },
    fechar () {
      this.limparCampos()
      this.$emit('fechar')
    }
  },
  watch: {
    redefinir (val) {
      if (val) {
        this.titulo = 'Redefina seu PIN'
      }
    }
  },
  created () {
    if (this.frentista) {
      this.login.email = this.frentista.pessoa.email
      if (this.frentistaSelecionado && this.frentista.id_frentista === this.frentistaSelecionado.id_frentista) {
        if (this.frentista.data_atualizacao_pin) {
          this.redefinir = true
        }
        this.step = 2
        this.texto = 'Confirme sua senha'
      } else {
        this.texto = '*Requer PIN do gerente'
      }
    }
  }
}
</script>
